import React from 'react';
import EnrollmentContent from '../../utils/EnrollmentContent';
import BaseEVerifyUsersMFA from './BaseEVerifyUsersMFA';

const CorporateAdminEverifyUsersMFA = (): JSX.Element => {
  return (
    <BaseEVerifyUsersMFA
      pageTitle="Corporate Administrator"
      primaryText={EnrollmentContent.everifyUsersCorporatePrimaryTextMFA}
    />
  );
};

export default CorporateAdminEverifyUsersMFA;
